import { defaultAxios, IParams } from './base';

export interface IGetLoanPreRequestCheck extends IParams {
  serverSearchTime: string;
}

export const getLoanPreRequestCheck = (params: any) => {
  return defaultAxios().post(`/loan/preReqChk`, params);
};
